import { AssessmentComp } from "../components/assessmentComp"
import { VerticalPageLayout } from "../components/layout"

export function Quiz({pageSwap}) {
    
    return (
        <VerticalPageLayout className={`assesment-page page-in-animation ${pageSwap && "page-out-animation"}`} style={{alignItems:"unset"}}>
            <AssessmentComp />
        </VerticalPageLayout>
    )
}